<template>
  <div class="pagehomeone">
    <!-- @change="handleChange" -->
    <el-carousel
      trigger="click"
      width="100vw"
      height="100vh"
      ref="carousel"
      :interval="4000"
      @mouseenter.native="delHandleMouseEnter"
      @change="handleChange"
    >
      <!-- :autoplay="false" -->
      <!-- <el-carousel-item v-for="(item, index) in data" :key="index">
        <img
          class="imgdata"
          :src="require(`../../img/${item.name}.jpeg`)"
          alt=""
        />
      </el-carousel-item> -->
      <el-carousel-item>
        <div id="pixi" @click="openpage">
          <div class="pixicenter">
            <!-- 来自大自然的力量与你相伴
            紫云因水而生 -->
            <div class="pixicenteritem">堆叠式水厂</div>
            <div class="pixicenteritem">相同处理量占地只有传统15%</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711001932"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="29786"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M913.94086 431.828053c-4.878101-25.783223-20.693298-42.455951-40.947598-42.455951l-3.511987 0c-54.731532 0-99.248422-44.515866-99.248422-99.262748 0-17.294898 8.299013-37.015032 8.619308-37.798884 10.097986-22.722514 2.349511-50.567699-18.078751-64.859193l-102.701057-57.183374-1.509377-0.738827c-20.545942-8.909927-48.667419-3.207042-63.987337 12.753465-11.086499 11.434423-49.306986 44.037982-78.471213 44.037982-29.543873 0-67.849294-33.257451-78.992075-44.908816-15.293311-16.077164-43.12417-22.112624-63.902402-13.218046l-106.35733 58.272171-1.596358 1.016143c-20.430308 14.234189-28.207435 42.078351-18.165732 64.713884 0.346901 0.827855 8.676613 20.387329 8.676613 37.914518 0 54.746882-44.51689 99.262748-99.247398 99.262748l-4.149507 0c-19.617803 0-35.434024 16.671705-40.309054 42.455951-0.363274 1.814322-8.590656 45.446052-8.590656 80.429821 0 34.938744 8.227382 78.555124 8.590656 80.355119 4.875031 25.799596 20.691251 42.48665 40.946574 42.48665l3.511987 0c54.730509 0 99.247398 44.51689 99.247398 99.247398 0 17.411555-8.328689 37.058011-8.647961 37.812187-10.069333 22.766516-2.349511 50.567699 18.021445 64.787562l100.756775 56.531528 1.538029 0.696872c20.836561 9.17087 49.01432 3.191692 64.250326-13.464663 14.07353-15.207353 52.207036-46.782489 80.20981-46.782489 30.354332 0 69.445652 35.347043 80.706113 47.76691 10.387581 11.376095 26.349111 18.22713 42.687218 18.22713 7.631818 0 14.857383-1.511423 21.474081-4.354168l104.4724-57.574277 1.538029-0.989537c20.428262-14.276145 28.206412-42.077328 18.138102-64.727187-0.348947-0.842181-8.677637-20.402679-8.677637-37.928844 0-54.730509 44.51689-99.247398 99.248422-99.247398l4.093225 0c19.644409 0 35.488259-16.687054 40.365336-42.48665 0.347924-1.799996 8.588609-45.416376 8.588609-80.355119C922.529469 477.274104 914.288784 433.642374 913.94086 431.828053M862.982258 512.257873c0 22.605857-4.498454 51.655474-6.559393 63.785745-82.09781 6.732331-145.738245 75.335802-145.738245 158.303422 0 23.419386 7.430226 45.851281 11.377118 56.169277l-89.12076 49.216935c-4.38282-4.584412-17.325597-17.644869-34.939767-30.762631-30.93557-22.925129-60.595077-34.635845-88.106664-34.635845-27.278273 0-56.703443 11.420097-87.493703 34.05563-17.528212 12.768815-30.296003 25.479301-34.765805 30.18037l-85.724407-47.997154c4.179183-10.839883 11.405771-32.982182 11.405771-56.226582 0-82.96762-63.640436-151.571091-145.70857-158.303422-2.089591-12.130272-6.588045-41.178865-6.588045-63.785745 0-22.650883 4.498454-51.713802 6.588045-63.844074 82.068134-6.718005 145.70857-75.335802 145.70857-158.303422 0-23.288402-7.429203-45.792952-11.376095-56.095599l91.325985-50.190099c3.975545 3.976568 17.005302 16.730033 34.82311 29.411867 30.355355 21.663392 59.260685 32.633235 86.016049 32.633235 26.494421 0 55.19509-10.766205 85.346807-32.009018 17.963117-12.623505 30.964222-25.203008 34.736129-28.757974l87.900979 48.825009c-3.975545 10.244318-11.405771 32.676214-11.405771 56.18258 0 82.96762 63.640436 151.585417 145.738245 158.303422C858.483804 460.5717 862.982258 489.7523 862.982258 512.257873"
                    fill="#fff"
                    p-id="29787"
                  ></path>
                  <path
                    d="M510.215866 365.633445c-80.530105 0-146.056494 65.527412-146.056494 146.057517 0 80.543408 65.527412 146.043191 146.056494 146.043191 80.530105 0 146.057517-65.499783 146.057517-146.043191C656.273383 431.160857 590.74597 365.633445 510.215866 365.633445M596.725148 511.690962c0 47.693232-38.799678 86.491887-86.509283 86.491887-47.708582 0-86.479607-38.798655-86.479607-86.491887 0-47.665603 38.771025-86.479607 86.479607-86.479607C557.925471 425.212378 596.725148 464.025359 596.725148 511.690962"
                    fill="#fff"
                    p-id="29788"
                  ></path>
                </svg>
                <div class="pixiiconitems">以工程服务为基石</div>
                <div class="pixiiconitems">以项目实施为核心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695710856522"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="28793"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M640 896h192V469.376h42.666667V896.213333c0 23.466667-19.029333 42.474667-42.666667 42.474667H597.333333V725.333333h-170.666666v213.333334H192c-23.573333 0-42.666667-18.986667-42.666667-42.453334V469.354667h42.666667V896h192V682.666667h256v213.333333z"
                    fill="#fff"
                    p-id="28794"
                  ></path>
                  <path
                    d="M100.032 506.133333a21.333333 21.333333 0 1 1-29.397333-30.933333L466.282667 99.349333a66.688 66.688 0 0 1 91.434666 0L953.386667 475.2a21.333333 21.333333 0 1 1-29.397334 30.933333L528.341333 130.282667a24.021333 24.021333 0 0 0-32.682666 0L100.053333 506.133333zM832 192h-128a21.333333 21.333333 0 0 1 0-42.666667h149.333333a21.333333 21.333333 0 0 1 21.333334 21.333334v149.333333a21.333333 21.333333 0 0 1-42.666667 0V192z"
                    fill="#fff"
                    p-id="28795"
                  ></path>
                </svg>
                <div class="pixiiconitems">以用心服务为信念</div>
                <div class="pixiiconitems">以专业能力为保障</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div id="pixione" @click="openpagetwo">
          <div class="pixicenter">
            <!-- 专注净水30年 -->
            <div class="pixicenteritem">全屋净水系统</div>
            <div class="pixicenteritem">从源头到杯口，用科技把健康锁进每一滴</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695711358682"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="30857"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M488.96 24.632889c-4.152889-5.575111-6.371556 0-6.371556 0L361.244444 1021.269333 492.259556 1024 488.96 24.632889zM273.237333 815.843556l-9.216-60.131556-32.142222 49.265778-65.080889-1.934222 41.358222 43.52-25.998222 57.344 58.197334-29.582223 43.52 41.415111-3.015112-62.293333 56.604445-25.6-64.284445-11.946667z m113.152-370.688l-65.820444 20.707555-30.549333-58.197333-19.911112 83.000889-70.428444 36.522666 55.864889 12.856889-12.970667 84.081778 54.328889-70.257778 64.284445 19.911111-22.983112-65.365333 48.184889-63.260444z m-302.307555 139.377777l-36.636445 49.436445-47.445333 7.850666 29.013333 31.687112-26.737777 54.385777 47.445333-37.546666 33.564444 32.654222 2.332445-52.337778 41.358222-33.621333-43.576889-2.048 0.682667-50.460445zM171.406222 413.582222l21.390222-26.737778-27.534222 6.940445-14.563555-25.713778-13.084445 39.537778-35.84 17.806222 24.462222 5.973333-6.087111 35.555556 29.013334-32.597333 29.070222 10.808889-6.826667-31.573334z m125.44-140.344889l13.824 7.964445 6.144-19.911111 21.333334-16.782223-16.782223-2.958222v-15.815111l-17.635555 20.821333-23.722667 3.982223 8.362667 15.701333-14.506667 20.764444 22.983111-13.767111zM893.155556 126.065778s-102.115556-65.251556-295.367112-19.456c0 0 246.954667-23.552 309.248 165.205333 0 0 43.008 191.488-104.106666 338.659556 0 0-106.382222 118.044444-177.322667 147.114666L531.171556 3.982222s-7.509333-12.458667-7.509334 6.997334v1002.040888s114.915556-40.220444 125.610667-59.733333l-15.018667-124.871111s315.790222-158.264889 380.188445-420.522667c0 0 60.131556-192.967111-121.287111-281.770666z"
                    fill="#fff"
                    p-id="30858"
                  ></path>
                </svg>

                <div class="pixiiconitems">获得多项</div>
                <div class="pixiiconitems">国内外专利</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711749431"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="32738"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M315.02 129.07c55.94-38.12 123.3-59.26 191-59.83 43.61-0.73 87.36 6.9 128.15 22.35 66.23 24.89 124.33 70.64 164.33 128.97 16.47 23.97 29.99 49.98 39.96 77.31 33.47 5.29 63.88 27.12 79.09 57.47 16.43 31.35 15.77 70.83-1.54 101.69-16.27 29.75-47.25 50.94-80.99 54.88-8.06 0.74-16.79 2.2-24.3-1.7-7.45-3.75-12.57-11.83-12.48-20.2 0.04-54.68-0.02-109.37 0.03-164.05 0.04-3.47-1.72-6.58-2.71-9.82-23.98-67.36-72.8-125.41-134.94-160.75-40.91-23.48-87.43-37.06-134.55-39.35-59.14-3.09-119.11 11.58-169.92 42.05-61.19 36.25-108.89 94.71-131.75 162.09-0.91 2.88-2.31 5.71-2.17 8.81 0.06 53.35-0.01 106.69 0.04 160.04 0.25 8.55-4.63 17.03-12.25 20.98-3.65 1.98-7.83 2.87-11.98 2.76-24.42-0.14-48.69-8.86-67.53-24.42-20.21-16.46-34.14-40.48-38.18-66.25-4.03-24.7 0.72-50.77 13.53-72.31 16.15-27.73 45.26-47.4 77.03-52 24.94-68.22 71.9-128.13 132.13-168.72M141.36 383.19c-5.11 13.55-5.22 28.94-0.15 42.52 5.76 16.16 18.7 29.45 34.52 35.97 0.03-37.99 0.03-75.98 0-113.97-15.66 6.51-28.46 19.56-34.37 35.48m703.4-35.43c-0.01 37.95-0.03 75.89 0.01 113.84 15.23-6.26 27.74-18.82 33.76-34.16 6.61-16.13 5.73-35.08-2.31-50.54-6.53-13.09-17.99-23.52-31.46-29.14z"
                    p-id="32739"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M503.35 170.33c38.72-1.15 77.76 7.39 112.26 25.1 34.69 17.52 64.77 44.02 86.72 76.09 20.03 29.16 33.27 62.97 38.24 98.01 5.94 41.06 0.81 83.72-15.05 122.08-13.35 32.53-34.25 61.9-60.52 85.26-28.64 25.57-63.71 43.9-101.09 52.67-44.3 10.46-91.68 7.71-134.38-8.12-30.37-11.16-58.28-28.85-81.49-51.38-26.98-26.18-47.59-58.96-59.15-94.75-18.29-55.57-14.55-118.05 10.41-170.99 25.23-54.25 72.21-97.94 128.24-118.98 24.19-9.22 49.94-14.22 75.81-14.99m-12.83 47.46c-27.55 2.86-54.43 12.03-77.97 26.64-23.29 14.34-43.35 33.89-58.29 56.8-17.52 26.65-27.95 57.91-29.91 89.74-2.7 40.08 8.04 80.94 30.31 114.39 19.74 30.11 48.45 54.23 81.48 68.55 35 15.28 74.77 19.27 112.13 11.41 36.61-7.5 70.68-26.57 96.46-53.6 23.04-23.99 39.5-54.26 46.93-86.69 9.58-40.98 4.71-85.19-13.75-123.02-14.96-31.03-38.75-57.71-67.83-76.17-35.12-22.59-78.06-32.56-119.56-28.05z"
                    p-id="32740"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M295.34 595.47c6.89-1.81 14.55-0.29 20.2 4.08 30.23 22.39 64.09 39.97 100.05 51.11 43.31 13.53 89.54 17.59 134.54 11.86 52.74-6.55 103.44-26.94 146.91-57.36 5.14-3.26 9.57-7.93 15.61-9.54 7.05-2.06 15.01-0.53 20.79 4.01 44.99 33.45 82.81 76.26 111.41 124.43 37.81 63.52 59.65 136.24 64.4 209.94 0.33 8.87-5.03 17.6-13.08 21.36-5.92 3.02-12.75 2.33-19.16 2.39h-732c-6.88-0.16-14.18 0.83-20.59-2.28-6.7-3.17-11.79-9.71-12.95-17.06-0.69-5.81 0.24-11.65 0.69-17.44 6.89-74.87 31.46-148.25 72.41-211.4 26.54-40.98 59.89-77.62 98.76-107.21 3.64-2.85 7.42-5.79 12.01-6.89m-46.7 105.1c-48.81 59.93-79.06 134.15-88.66 210.68 233.46 0 466.91 0.02 700.37-0.01-6.01-48.63-20.41-96.25-42.64-139.93-24.17-47.57-57.84-90.45-99.18-124.28-50.76 34.13-109.66 56.44-170.62 62.58-46.12 4.77-93.16 0.75-137.75-11.99-38.52-10.88-75.06-28.3-108.27-50.58a374.732 374.732 0 0 0-53.25 53.53z"
                    p-id="32741"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M456.35 784.58a22.42 22.42 0 0 1 6.61-1.08c31.35-0.01 62.7 0.01 94.05-0.01 7.35-0.02 14.6 3.71 18.81 9.75 5.74 7.93 5.73 19.58-0.13 27.45-4.24 5.89-11.37 9.71-18.67 9.58-31.69-0.07-63.38 0.04-95.07-0.05-11.53-0.33-21.59-10.66-21.72-22.18-0.82-10.32 6.28-20.44 16.12-23.46z"
                    p-id="32742"
                    fill="#ffffff"
                  ></path>
                </svg>
                <div class="pixiiconitems">技术服务覆盖</div>
                <div class="pixiiconitems">全国多个省市</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div id="pixitwo" @click="openpagethree">
          <div class="pixicenter">
            <!-- P&C紫云
            水生命之源万物之魂
            水梦紫云间 -->
            <div class="pixicenteritem">污水一体化装备</div>
            <div class="pixicenteritem">模块化设计+智能控污，小体积藏大能量</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711001932"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="29786"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M913.94086 431.828053c-4.878101-25.783223-20.693298-42.455951-40.947598-42.455951l-3.511987 0c-54.731532 0-99.248422-44.515866-99.248422-99.262748 0-17.294898 8.299013-37.015032 8.619308-37.798884 10.097986-22.722514 2.349511-50.567699-18.078751-64.859193l-102.701057-57.183374-1.509377-0.738827c-20.545942-8.909927-48.667419-3.207042-63.987337 12.753465-11.086499 11.434423-49.306986 44.037982-78.471213 44.037982-29.543873 0-67.849294-33.257451-78.992075-44.908816-15.293311-16.077164-43.12417-22.112624-63.902402-13.218046l-106.35733 58.272171-1.596358 1.016143c-20.430308 14.234189-28.207435 42.078351-18.165732 64.713884 0.346901 0.827855 8.676613 20.387329 8.676613 37.914518 0 54.746882-44.51689 99.262748-99.247398 99.262748l-4.149507 0c-19.617803 0-35.434024 16.671705-40.309054 42.455951-0.363274 1.814322-8.590656 45.446052-8.590656 80.429821 0 34.938744 8.227382 78.555124 8.590656 80.355119 4.875031 25.799596 20.691251 42.48665 40.946574 42.48665l3.511987 0c54.730509 0 99.247398 44.51689 99.247398 99.247398 0 17.411555-8.328689 37.058011-8.647961 37.812187-10.069333 22.766516-2.349511 50.567699 18.021445 64.787562l100.756775 56.531528 1.538029 0.696872c20.836561 9.17087 49.01432 3.191692 64.250326-13.464663 14.07353-15.207353 52.207036-46.782489 80.20981-46.782489 30.354332 0 69.445652 35.347043 80.706113 47.76691 10.387581 11.376095 26.349111 18.22713 42.687218 18.22713 7.631818 0 14.857383-1.511423 21.474081-4.354168l104.4724-57.574277 1.538029-0.989537c20.428262-14.276145 28.206412-42.077328 18.138102-64.727187-0.348947-0.842181-8.677637-20.402679-8.677637-37.928844 0-54.730509 44.51689-99.247398 99.248422-99.247398l4.093225 0c19.644409 0 35.488259-16.687054 40.365336-42.48665 0.347924-1.799996 8.588609-45.416376 8.588609-80.355119C922.529469 477.274104 914.288784 433.642374 913.94086 431.828053M862.982258 512.257873c0 22.605857-4.498454 51.655474-6.559393 63.785745-82.09781 6.732331-145.738245 75.335802-145.738245 158.303422 0 23.419386 7.430226 45.851281 11.377118 56.169277l-89.12076 49.216935c-4.38282-4.584412-17.325597-17.644869-34.939767-30.762631-30.93557-22.925129-60.595077-34.635845-88.106664-34.635845-27.278273 0-56.703443 11.420097-87.493703 34.05563-17.528212 12.768815-30.296003 25.479301-34.765805 30.18037l-85.724407-47.997154c4.179183-10.839883 11.405771-32.982182 11.405771-56.226582 0-82.96762-63.640436-151.571091-145.70857-158.303422-2.089591-12.130272-6.588045-41.178865-6.588045-63.785745 0-22.650883 4.498454-51.713802 6.588045-63.844074 82.068134-6.718005 145.70857-75.335802 145.70857-158.303422 0-23.288402-7.429203-45.792952-11.376095-56.095599l91.325985-50.190099c3.975545 3.976568 17.005302 16.730033 34.82311 29.411867 30.355355 21.663392 59.260685 32.633235 86.016049 32.633235 26.494421 0 55.19509-10.766205 85.346807-32.009018 17.963117-12.623505 30.964222-25.203008 34.736129-28.757974l87.900979 48.825009c-3.975545 10.244318-11.405771 32.676214-11.405771 56.18258 0 82.96762 63.640436 151.585417 145.738245 158.303422C858.483804 460.5717 862.982258 489.7523 862.982258 512.257873"
                    fill="#fff"
                    p-id="29787"
                  ></path>
                  <path
                    d="M510.215866 365.633445c-80.530105 0-146.056494 65.527412-146.056494 146.057517 0 80.543408 65.527412 146.043191 146.056494 146.043191 80.530105 0 146.057517-65.499783 146.057517-146.043191C656.273383 431.160857 590.74597 365.633445 510.215866 365.633445M596.725148 511.690962c0 47.693232-38.799678 86.491887-86.509283 86.491887-47.708582 0-86.479607-38.798655-86.479607-86.491887 0-47.665603 38.771025-86.479607 86.479607-86.479607C557.925471 425.212378 596.725148 464.025359 596.725148 511.690962"
                    fill="#fff"
                    p-id="29788"
                  ></path>
                </svg>
                <div class="pixiiconitems">以工程服务为基石</div>
                <div class="pixiiconitems">以项目实施为核心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695710856522"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="28793"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M640 896h192V469.376h42.666667V896.213333c0 23.466667-19.029333 42.474667-42.666667 42.474667H597.333333V725.333333h-170.666666v213.333334H192c-23.573333 0-42.666667-18.986667-42.666667-42.453334V469.354667h42.666667V896h192V682.666667h256v213.333333z"
                    fill="#fff"
                    p-id="28794"
                  ></path>
                  <path
                    d="M100.032 506.133333a21.333333 21.333333 0 1 1-29.397333-30.933333L466.282667 99.349333a66.688 66.688 0 0 1 91.434666 0L953.386667 475.2a21.333333 21.333333 0 1 1-29.397334 30.933333L528.341333 130.282667a24.021333 24.021333 0 0 0-32.682666 0L100.053333 506.133333zM832 192h-128a21.333333 21.333333 0 0 1 0-42.666667h149.333333a21.333333 21.333333 0 0 1 21.333334 21.333334v149.333333a21.333333 21.333333 0 0 1-42.666667 0V192z"
                    fill="#fff"
                    p-id="28795"
                  ></path>
                </svg>
                <div class="pixiiconitems">以用心服务为信念</div>
                <div class="pixiiconitems">以专业能力为保障</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div id="pixithree" @click="openpagefour">
          <div class="pixicenter">
            <!-- P&C紫云
            净化生命水健康全世界
            水润紫云清 -->
            <div class="pixicenteritem">P&C紫云</div>
            <div class="pixicenteritem">模块化净水系统 让健康饮水像呼吸一样简单</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695711358682"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="30857"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M488.96 24.632889c-4.152889-5.575111-6.371556 0-6.371556 0L361.244444 1021.269333 492.259556 1024 488.96 24.632889zM273.237333 815.843556l-9.216-60.131556-32.142222 49.265778-65.080889-1.934222 41.358222 43.52-25.998222 57.344 58.197334-29.582223 43.52 41.415111-3.015112-62.293333 56.604445-25.6-64.284445-11.946667z m113.152-370.688l-65.820444 20.707555-30.549333-58.197333-19.911112 83.000889-70.428444 36.522666 55.864889 12.856889-12.970667 84.081778 54.328889-70.257778 64.284445 19.911111-22.983112-65.365333 48.184889-63.260444z m-302.307555 139.377777l-36.636445 49.436445-47.445333 7.850666 29.013333 31.687112-26.737777 54.385777 47.445333-37.546666 33.564444 32.654222 2.332445-52.337778 41.358222-33.621333-43.576889-2.048 0.682667-50.460445zM171.406222 413.582222l21.390222-26.737778-27.534222 6.940445-14.563555-25.713778-13.084445 39.537778-35.84 17.806222 24.462222 5.973333-6.087111 35.555556 29.013334-32.597333 29.070222 10.808889-6.826667-31.573334z m125.44-140.344889l13.824 7.964445 6.144-19.911111 21.333334-16.782223-16.782223-2.958222v-15.815111l-17.635555 20.821333-23.722667 3.982223 8.362667 15.701333-14.506667 20.764444 22.983111-13.767111zM893.155556 126.065778s-102.115556-65.251556-295.367112-19.456c0 0 246.954667-23.552 309.248 165.205333 0 0 43.008 191.488-104.106666 338.659556 0 0-106.382222 118.044444-177.322667 147.114666L531.171556 3.982222s-7.509333-12.458667-7.509334 6.997334v1002.040888s114.915556-40.220444 125.610667-59.733333l-15.018667-124.871111s315.790222-158.264889 380.188445-420.522667c0 0 60.131556-192.967111-121.287111-281.770666z"
                    fill="#fff"
                    p-id="30858"
                  ></path>
                </svg>

                <div class="pixiiconitems">获得多项</div>
                <div class="pixiiconitems">国内外专利</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711749431"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="32738"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M315.02 129.07c55.94-38.12 123.3-59.26 191-59.83 43.61-0.73 87.36 6.9 128.15 22.35 66.23 24.89 124.33 70.64 164.33 128.97 16.47 23.97 29.99 49.98 39.96 77.31 33.47 5.29 63.88 27.12 79.09 57.47 16.43 31.35 15.77 70.83-1.54 101.69-16.27 29.75-47.25 50.94-80.99 54.88-8.06 0.74-16.79 2.2-24.3-1.7-7.45-3.75-12.57-11.83-12.48-20.2 0.04-54.68-0.02-109.37 0.03-164.05 0.04-3.47-1.72-6.58-2.71-9.82-23.98-67.36-72.8-125.41-134.94-160.75-40.91-23.48-87.43-37.06-134.55-39.35-59.14-3.09-119.11 11.58-169.92 42.05-61.19 36.25-108.89 94.71-131.75 162.09-0.91 2.88-2.31 5.71-2.17 8.81 0.06 53.35-0.01 106.69 0.04 160.04 0.25 8.55-4.63 17.03-12.25 20.98-3.65 1.98-7.83 2.87-11.98 2.76-24.42-0.14-48.69-8.86-67.53-24.42-20.21-16.46-34.14-40.48-38.18-66.25-4.03-24.7 0.72-50.77 13.53-72.31 16.15-27.73 45.26-47.4 77.03-52 24.94-68.22 71.9-128.13 132.13-168.72M141.36 383.19c-5.11 13.55-5.22 28.94-0.15 42.52 5.76 16.16 18.7 29.45 34.52 35.97 0.03-37.99 0.03-75.98 0-113.97-15.66 6.51-28.46 19.56-34.37 35.48m703.4-35.43c-0.01 37.95-0.03 75.89 0.01 113.84 15.23-6.26 27.74-18.82 33.76-34.16 6.61-16.13 5.73-35.08-2.31-50.54-6.53-13.09-17.99-23.52-31.46-29.14z"
                    p-id="32739"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M503.35 170.33c38.72-1.15 77.76 7.39 112.26 25.1 34.69 17.52 64.77 44.02 86.72 76.09 20.03 29.16 33.27 62.97 38.24 98.01 5.94 41.06 0.81 83.72-15.05 122.08-13.35 32.53-34.25 61.9-60.52 85.26-28.64 25.57-63.71 43.9-101.09 52.67-44.3 10.46-91.68 7.71-134.38-8.12-30.37-11.16-58.28-28.85-81.49-51.38-26.98-26.18-47.59-58.96-59.15-94.75-18.29-55.57-14.55-118.05 10.41-170.99 25.23-54.25 72.21-97.94 128.24-118.98 24.19-9.22 49.94-14.22 75.81-14.99m-12.83 47.46c-27.55 2.86-54.43 12.03-77.97 26.64-23.29 14.34-43.35 33.89-58.29 56.8-17.52 26.65-27.95 57.91-29.91 89.74-2.7 40.08 8.04 80.94 30.31 114.39 19.74 30.11 48.45 54.23 81.48 68.55 35 15.28 74.77 19.27 112.13 11.41 36.61-7.5 70.68-26.57 96.46-53.6 23.04-23.99 39.5-54.26 46.93-86.69 9.58-40.98 4.71-85.19-13.75-123.02-14.96-31.03-38.75-57.71-67.83-76.17-35.12-22.59-78.06-32.56-119.56-28.05z"
                    p-id="32740"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M295.34 595.47c6.89-1.81 14.55-0.29 20.2 4.08 30.23 22.39 64.09 39.97 100.05 51.11 43.31 13.53 89.54 17.59 134.54 11.86 52.74-6.55 103.44-26.94 146.91-57.36 5.14-3.26 9.57-7.93 15.61-9.54 7.05-2.06 15.01-0.53 20.79 4.01 44.99 33.45 82.81 76.26 111.41 124.43 37.81 63.52 59.65 136.24 64.4 209.94 0.33 8.87-5.03 17.6-13.08 21.36-5.92 3.02-12.75 2.33-19.16 2.39h-732c-6.88-0.16-14.18 0.83-20.59-2.28-6.7-3.17-11.79-9.71-12.95-17.06-0.69-5.81 0.24-11.65 0.69-17.44 6.89-74.87 31.46-148.25 72.41-211.4 26.54-40.98 59.89-77.62 98.76-107.21 3.64-2.85 7.42-5.79 12.01-6.89m-46.7 105.1c-48.81 59.93-79.06 134.15-88.66 210.68 233.46 0 466.91 0.02 700.37-0.01-6.01-48.63-20.41-96.25-42.64-139.93-24.17-47.57-57.84-90.45-99.18-124.28-50.76 34.13-109.66 56.44-170.62 62.58-46.12 4.77-93.16 0.75-137.75-11.99-38.52-10.88-75.06-28.3-108.27-50.58a374.732 374.732 0 0 0-53.25 53.53z"
                    p-id="32741"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M456.35 784.58a22.42 22.42 0 0 1 6.61-1.08c31.35-0.01 62.7 0.01 94.05-0.01 7.35-0.02 14.6 3.71 18.81 9.75 5.74 7.93 5.73 19.58-0.13 27.45-4.24 5.89-11.37 9.71-18.67 9.58-31.69-0.07-63.38 0.04-95.07-0.05-11.53-0.33-21.59-10.66-21.72-22.18-0.82-10.32 6.28-20.44 16.12-23.46z"
                    p-id="32742"
                    fill="#ffffff"
                  ></path>
                </svg>
                <div class="pixiiconitems">技术服务覆盖</div>
                <div class="pixiiconitems">全国多个省市</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div id="pixifour" @click="openpagefive">
          <div class="pixicenter">
            <!-- P&C紫云
            水生命之源万物之魂
            水梦紫云间 -->
            <div class="pixicenteritem">P&C紫云</div>
            <div class="pixicenteritem">智慧水务系统</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711001932"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="29786"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M913.94086 431.828053c-4.878101-25.783223-20.693298-42.455951-40.947598-42.455951l-3.511987 0c-54.731532 0-99.248422-44.515866-99.248422-99.262748 0-17.294898 8.299013-37.015032 8.619308-37.798884 10.097986-22.722514 2.349511-50.567699-18.078751-64.859193l-102.701057-57.183374-1.509377-0.738827c-20.545942-8.909927-48.667419-3.207042-63.987337 12.753465-11.086499 11.434423-49.306986 44.037982-78.471213 44.037982-29.543873 0-67.849294-33.257451-78.992075-44.908816-15.293311-16.077164-43.12417-22.112624-63.902402-13.218046l-106.35733 58.272171-1.596358 1.016143c-20.430308 14.234189-28.207435 42.078351-18.165732 64.713884 0.346901 0.827855 8.676613 20.387329 8.676613 37.914518 0 54.746882-44.51689 99.262748-99.247398 99.262748l-4.149507 0c-19.617803 0-35.434024 16.671705-40.309054 42.455951-0.363274 1.814322-8.590656 45.446052-8.590656 80.429821 0 34.938744 8.227382 78.555124 8.590656 80.355119 4.875031 25.799596 20.691251 42.48665 40.946574 42.48665l3.511987 0c54.730509 0 99.247398 44.51689 99.247398 99.247398 0 17.411555-8.328689 37.058011-8.647961 37.812187-10.069333 22.766516-2.349511 50.567699 18.021445 64.787562l100.756775 56.531528 1.538029 0.696872c20.836561 9.17087 49.01432 3.191692 64.250326-13.464663 14.07353-15.207353 52.207036-46.782489 80.20981-46.782489 30.354332 0 69.445652 35.347043 80.706113 47.76691 10.387581 11.376095 26.349111 18.22713 42.687218 18.22713 7.631818 0 14.857383-1.511423 21.474081-4.354168l104.4724-57.574277 1.538029-0.989537c20.428262-14.276145 28.206412-42.077328 18.138102-64.727187-0.348947-0.842181-8.677637-20.402679-8.677637-37.928844 0-54.730509 44.51689-99.247398 99.248422-99.247398l4.093225 0c19.644409 0 35.488259-16.687054 40.365336-42.48665 0.347924-1.799996 8.588609-45.416376 8.588609-80.355119C922.529469 477.274104 914.288784 433.642374 913.94086 431.828053M862.982258 512.257873c0 22.605857-4.498454 51.655474-6.559393 63.785745-82.09781 6.732331-145.738245 75.335802-145.738245 158.303422 0 23.419386 7.430226 45.851281 11.377118 56.169277l-89.12076 49.216935c-4.38282-4.584412-17.325597-17.644869-34.939767-30.762631-30.93557-22.925129-60.595077-34.635845-88.106664-34.635845-27.278273 0-56.703443 11.420097-87.493703 34.05563-17.528212 12.768815-30.296003 25.479301-34.765805 30.18037l-85.724407-47.997154c4.179183-10.839883 11.405771-32.982182 11.405771-56.226582 0-82.96762-63.640436-151.571091-145.70857-158.303422-2.089591-12.130272-6.588045-41.178865-6.588045-63.785745 0-22.650883 4.498454-51.713802 6.588045-63.844074 82.068134-6.718005 145.70857-75.335802 145.70857-158.303422 0-23.288402-7.429203-45.792952-11.376095-56.095599l91.325985-50.190099c3.975545 3.976568 17.005302 16.730033 34.82311 29.411867 30.355355 21.663392 59.260685 32.633235 86.016049 32.633235 26.494421 0 55.19509-10.766205 85.346807-32.009018 17.963117-12.623505 30.964222-25.203008 34.736129-28.757974l87.900979 48.825009c-3.975545 10.244318-11.405771 32.676214-11.405771 56.18258 0 82.96762 63.640436 151.585417 145.738245 158.303422C858.483804 460.5717 862.982258 489.7523 862.982258 512.257873"
                    fill="#fff"
                    p-id="29787"
                  ></path>
                  <path
                    d="M510.215866 365.633445c-80.530105 0-146.056494 65.527412-146.056494 146.057517 0 80.543408 65.527412 146.043191 146.056494 146.043191 80.530105 0 146.057517-65.499783 146.057517-146.043191C656.273383 431.160857 590.74597 365.633445 510.215866 365.633445M596.725148 511.690962c0 47.693232-38.799678 86.491887-86.509283 86.491887-47.708582 0-86.479607-38.798655-86.479607-86.491887 0-47.665603 38.771025-86.479607 86.479607-86.479607C557.925471 425.212378 596.725148 464.025359 596.725148 511.690962"
                    fill="#fff"
                    p-id="29788"
                  ></path>
                </svg>
                <div class="pixiiconitems">以工程服务为基石</div>
                <div class="pixiiconitems">以项目实施为核心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695710856522"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="28793"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M640 896h192V469.376h42.666667V896.213333c0 23.466667-19.029333 42.474667-42.666667 42.474667H597.333333V725.333333h-170.666666v213.333334H192c-23.573333 0-42.666667-18.986667-42.666667-42.453334V469.354667h42.666667V896h192V682.666667h256v213.333333z"
                    fill="#fff"
                    p-id="28794"
                  ></path>
                  <path
                    d="M100.032 506.133333a21.333333 21.333333 0 1 1-29.397333-30.933333L466.282667 99.349333a66.688 66.688 0 0 1 91.434666 0L953.386667 475.2a21.333333 21.333333 0 1 1-29.397334 30.933333L528.341333 130.282667a24.021333 24.021333 0 0 0-32.682666 0L100.053333 506.133333zM832 192h-128a21.333333 21.333333 0 0 1 0-42.666667h149.333333a21.333333 21.333333 0 0 1 21.333334 21.333334v149.333333a21.333333 21.333333 0 0 1-42.666667 0V192z"
                    fill="#fff"
                    p-id="28795"
                  ></path>
                </svg>
                <div class="pixiiconitems">以用心服务为信念</div>
                <div class="pixiiconitems">以专业能力为保障</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div id="pixifive" @click="openpagesix">
          <div class="pixicenter">
            <!-- P&C紫云
            净化生命水健康全世界
            水润紫云清 -->
            <div class="pixicenteritem">一体化污水处理设备</div>
            <div class="pixicenteritem">自动运行+远程监控，一台轻松破解污水难题</div>
            <div class="pixiiconcenter">
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695709906736"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="25571"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M431.616 11.776l352.768 179.2v109.056h-78.336V231.936L509.952 132.608v760.832l195.584-99.328v-68.096h78.336V834.56l-352.768 179.2V11.776z m-294.4 901.12c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z m68.096-197.632c-14.848 0-29.184-4.096-41.984-11.264-26.112-14.848-42.496-42.496-42.496-72.192 0-29.696 16.384-57.344 42.496-72.192 13.312-7.168 27.648-11.264 41.984-11.264 14.336 0 29.184 3.584 41.984 11.264 26.112 14.848 42.496 42.496 42.496 72.192 0 29.696-16.384 57.344-42.496 72.192-12.8 7.168-27.136 11.264-41.984 11.264z m731.136-46.592c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216z m-193.024 0c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096zM314.88 496.128c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 5.632-22.016 9.216-33.792 9.216z m428.544-5.12c-35.84 0-65.536-27.648-68.096-62.976v-5.12c0-37.376 30.72-68.096 68.608-68.096s68.096 30.72 68.096 68.096c-0.512 37.888-31.232 68.096-68.608 68.096z m193.024 0c-11.776 0-24.064-3.072-34.304-9.216-20.992-12.288-34.304-34.816-34.304-58.88s13.312-46.592 34.304-58.88c10.24-6.144 22.016-9.216 34.304-9.216 11.776 0 24.064 3.072 34.304 9.216 20.992 12.288 34.304 34.816 34.304 58.88s-13.312 46.592-34.304 58.88c-10.24 6.144-22.016 9.216-34.304 9.216zM79.872 370.688c-11.776 0-23.552-3.072-33.792-9.216-20.48-11.776-33.792-34.304-33.792-58.368S25.088 256.512 46.08 244.736c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.992 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.752 6.144-22.016 9.216-33.792 9.216z m159.232-156.672c-11.776 0-23.552-3.072-33.792-9.216-20.48-12.288-33.792-34.304-33.792-58.368s12.8-46.592 33.792-58.368c10.24-6.144 22.016-9.216 33.792-9.216s23.552 3.072 33.792 9.216c20.48 12.288 33.792 34.304 33.792 58.368s-12.8 46.592-33.792 58.368c-10.24 6.144-22.016 9.216-33.792 9.216z"
                    fill="#fff"
                    p-id="25572"
                  ></path>
                </svg>
                <div class="pixiiconitems">以科技研发为龙头</div>
                <div class="pixiiconitems">以技术创新为中心</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  t="1695711358682"
                  style="margin-bottom: 20px"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="30857"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M488.96 24.632889c-4.152889-5.575111-6.371556 0-6.371556 0L361.244444 1021.269333 492.259556 1024 488.96 24.632889zM273.237333 815.843556l-9.216-60.131556-32.142222 49.265778-65.080889-1.934222 41.358222 43.52-25.998222 57.344 58.197334-29.582223 43.52 41.415111-3.015112-62.293333 56.604445-25.6-64.284445-11.946667z m113.152-370.688l-65.820444 20.707555-30.549333-58.197333-19.911112 83.000889-70.428444 36.522666 55.864889 12.856889-12.970667 84.081778 54.328889-70.257778 64.284445 19.911111-22.983112-65.365333 48.184889-63.260444z m-302.307555 139.377777l-36.636445 49.436445-47.445333 7.850666 29.013333 31.687112-26.737777 54.385777 47.445333-37.546666 33.564444 32.654222 2.332445-52.337778 41.358222-33.621333-43.576889-2.048 0.682667-50.460445zM171.406222 413.582222l21.390222-26.737778-27.534222 6.940445-14.563555-25.713778-13.084445 39.537778-35.84 17.806222 24.462222 5.973333-6.087111 35.555556 29.013334-32.597333 29.070222 10.808889-6.826667-31.573334z m125.44-140.344889l13.824 7.964445 6.144-19.911111 21.333334-16.782223-16.782223-2.958222v-15.815111l-17.635555 20.821333-23.722667 3.982223 8.362667 15.701333-14.506667 20.764444 22.983111-13.767111zM893.155556 126.065778s-102.115556-65.251556-295.367112-19.456c0 0 246.954667-23.552 309.248 165.205333 0 0 43.008 191.488-104.106666 338.659556 0 0-106.382222 118.044444-177.322667 147.114666L531.171556 3.982222s-7.509333-12.458667-7.509334 6.997334v1002.040888s114.915556-40.220444 125.610667-59.733333l-15.018667-124.871111s315.790222-158.264889 380.188445-420.522667c0 0 60.131556-192.967111-121.287111-281.770666z"
                    fill="#fff"
                    p-id="30858"
                  ></path>
                </svg>

                <div class="pixiiconitems">获得多项</div>
                <div class="pixiiconitems">国内外专利</div>
              </div>
              <div class="pixiiconitem">
                <svg
                  style="margin-bottom: 20px"
                  t="1695711749431"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="32738"
                  :width="iconwidth"
                  :height="iconheight"
                >
                  <path
                    d="M315.02 129.07c55.94-38.12 123.3-59.26 191-59.83 43.61-0.73 87.36 6.9 128.15 22.35 66.23 24.89 124.33 70.64 164.33 128.97 16.47 23.97 29.99 49.98 39.96 77.31 33.47 5.29 63.88 27.12 79.09 57.47 16.43 31.35 15.77 70.83-1.54 101.69-16.27 29.75-47.25 50.94-80.99 54.88-8.06 0.74-16.79 2.2-24.3-1.7-7.45-3.75-12.57-11.83-12.48-20.2 0.04-54.68-0.02-109.37 0.03-164.05 0.04-3.47-1.72-6.58-2.71-9.82-23.98-67.36-72.8-125.41-134.94-160.75-40.91-23.48-87.43-37.06-134.55-39.35-59.14-3.09-119.11 11.58-169.92 42.05-61.19 36.25-108.89 94.71-131.75 162.09-0.91 2.88-2.31 5.71-2.17 8.81 0.06 53.35-0.01 106.69 0.04 160.04 0.25 8.55-4.63 17.03-12.25 20.98-3.65 1.98-7.83 2.87-11.98 2.76-24.42-0.14-48.69-8.86-67.53-24.42-20.21-16.46-34.14-40.48-38.18-66.25-4.03-24.7 0.72-50.77 13.53-72.31 16.15-27.73 45.26-47.4 77.03-52 24.94-68.22 71.9-128.13 132.13-168.72M141.36 383.19c-5.11 13.55-5.22 28.94-0.15 42.52 5.76 16.16 18.7 29.45 34.52 35.97 0.03-37.99 0.03-75.98 0-113.97-15.66 6.51-28.46 19.56-34.37 35.48m703.4-35.43c-0.01 37.95-0.03 75.89 0.01 113.84 15.23-6.26 27.74-18.82 33.76-34.16 6.61-16.13 5.73-35.08-2.31-50.54-6.53-13.09-17.99-23.52-31.46-29.14z"
                    p-id="32739"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M503.35 170.33c38.72-1.15 77.76 7.39 112.26 25.1 34.69 17.52 64.77 44.02 86.72 76.09 20.03 29.16 33.27 62.97 38.24 98.01 5.94 41.06 0.81 83.72-15.05 122.08-13.35 32.53-34.25 61.9-60.52 85.26-28.64 25.57-63.71 43.9-101.09 52.67-44.3 10.46-91.68 7.71-134.38-8.12-30.37-11.16-58.28-28.85-81.49-51.38-26.98-26.18-47.59-58.96-59.15-94.75-18.29-55.57-14.55-118.05 10.41-170.99 25.23-54.25 72.21-97.94 128.24-118.98 24.19-9.22 49.94-14.22 75.81-14.99m-12.83 47.46c-27.55 2.86-54.43 12.03-77.97 26.64-23.29 14.34-43.35 33.89-58.29 56.8-17.52 26.65-27.95 57.91-29.91 89.74-2.7 40.08 8.04 80.94 30.31 114.39 19.74 30.11 48.45 54.23 81.48 68.55 35 15.28 74.77 19.27 112.13 11.41 36.61-7.5 70.68-26.57 96.46-53.6 23.04-23.99 39.5-54.26 46.93-86.69 9.58-40.98 4.71-85.19-13.75-123.02-14.96-31.03-38.75-57.71-67.83-76.17-35.12-22.59-78.06-32.56-119.56-28.05z"
                    p-id="32740"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M295.34 595.47c6.89-1.81 14.55-0.29 20.2 4.08 30.23 22.39 64.09 39.97 100.05 51.11 43.31 13.53 89.54 17.59 134.54 11.86 52.74-6.55 103.44-26.94 146.91-57.36 5.14-3.26 9.57-7.93 15.61-9.54 7.05-2.06 15.01-0.53 20.79 4.01 44.99 33.45 82.81 76.26 111.41 124.43 37.81 63.52 59.65 136.24 64.4 209.94 0.33 8.87-5.03 17.6-13.08 21.36-5.92 3.02-12.75 2.33-19.16 2.39h-732c-6.88-0.16-14.18 0.83-20.59-2.28-6.7-3.17-11.79-9.71-12.95-17.06-0.69-5.81 0.24-11.65 0.69-17.44 6.89-74.87 31.46-148.25 72.41-211.4 26.54-40.98 59.89-77.62 98.76-107.21 3.64-2.85 7.42-5.79 12.01-6.89m-46.7 105.1c-48.81 59.93-79.06 134.15-88.66 210.68 233.46 0 466.91 0.02 700.37-0.01-6.01-48.63-20.41-96.25-42.64-139.93-24.17-47.57-57.84-90.45-99.18-124.28-50.76 34.13-109.66 56.44-170.62 62.58-46.12 4.77-93.16 0.75-137.75-11.99-38.52-10.88-75.06-28.3-108.27-50.58a374.732 374.732 0 0 0-53.25 53.53z"
                    p-id="32741"
                    fill="#ffffff"
                  ></path>
                  <path
                    d="M456.35 784.58a22.42 22.42 0 0 1 6.61-1.08c31.35-0.01 62.7 0.01 94.05-0.01 7.35-0.02 14.6 3.71 18.81 9.75 5.74 7.93 5.73 19.58-0.13 27.45-4.24 5.89-11.37 9.71-18.67 9.58-31.69-0.07-63.38 0.04-95.07-0.05-11.53-0.33-21.59-10.66-21.72-22.18-0.82-10.32 6.28-20.44 16.12-23.46z"
                    p-id="32742"
                    fill="#ffffff"
                  ></path>
                </svg>
                <div class="pixiiconitems">技术服务覆盖</div>
                <div class="pixiiconitems">全国多个省市</div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="progress">
      <Progress />
      <div class="progressitem">探索更多</div>
    </div>
  </div>
</template>

<script>
import { Assets } from 'pixi.js'
import { getpageimg } from '@/api/index.js'
import Progress from '../component/progress'
import * as PIXI from 'pixi.js'
import { log } from 'three'

export default {
  name: 'App',
  props: ['donghuastate'],
  components: {
    Progress,
  },
  watch: {
    donghuastate(val, old) {
      if (val) {
        this.destroyPixiApp()
      } else {
        this.openPixiApp()
      }
    },
  },
  mounted() {
    let screenWidths = document.body.clientWidth
    if (screenWidths >= 550) {
      this.data = [
        {
          name: 'page1',
          id: 'pixi',
          app: null,
        },
        {
          name: 'page2',
          id: 'pixione',
          app: null,
        },
        {
          name: 'page3',
          id: 'pixitwo',
          app: null,
        },
        {
          name: 'page4',
          id: 'pixithree',
          app: null,
        },
        {
          name: 'page5',
          id: 'pixifour',
          app: null,
        },
        {
          name: 'page6',
          id: 'pixifive',
          app: null,
        },
      ]
      this.initPixi(this.data[0])
      // getpageimg().then((items) => {
      //   this.data = []
      //   if (items.status == 200) {
      //   for (let i = 0; i < items.data.length; i++) {
      //     if (i== 0) {
      //         this.data.push({
      //           name: items.data[i].image,
      //           id: 'pixi',
      //           app: null,
      //         })
      //       } else if (i== 1) {
      //         this.data.push({
      //           name:  items.data[i].image,
      //           id: 'pixione',
      //           app: null,
      //         })
      //       } else if (i== 2) {
      //         this.data.push({
      //           name:  items.data[i].image,
      //           id: 'pixitwo',
      //           app: null,
      //         })
      //       } else if (i== 3) {
      //         this.data.push({
      //           name:  items.data[i].image,
      //           id: 'pixithree',
      //           app: null,
      //         })
      //       }
      //   }
      //     this.initPixi(this.data[0])
      //   }
      // })
    } else if (screenWidths < 550) {
      this.data = [
        {
          name: 'page1s',
          id: 'pixi',
          app: null,
        },
        {
          name: 'page2s',
          id: 'pixione',
          app: null,
        },
        {
          name: 'page3s',
          id: 'pixitwo',
          app: null,
        },
        {
          name: 'page4s',
          id: 'pixithree',
          app: null,
        },
        {
          name: 'page5s',
          id: 'pixifour',
          app: null,
        },
        {
          name: 'page6s',
          id: 'pixifive',
          app: null,
        },
      ]
      this.initPixi(this.data[0])
      // getpageimg().then((items) => {
      //   this.data = []
      //   if (items.status == 200) {
      //     for (let i = 0; i < items.data.length; i++) {
      //       if (i == 0) {
      //         this.data.push({
      //           name: items.data[i].image,
      //           id: 'pixi',
      //           app: null,
      //         })
      //       } else if (i == 1) {
      //         this.data.push({
      //           name: items.data[i].image,
      //           id: 'pixione',
      //           app: null,
      //         })
      //       } else if (i == 2) {
      //         this.data.push({
      //           name: items.data[i].image,
      //           id: 'pixitwo',
      //           app: null,
      //         })
      //       } else if (i == 3) {
      //         this.data.push({
      //           name: items.data[i].image,
      //           id: 'pixithree',
      //           app: null,
      //         })
      //       }
      //     }
      //     this.initPixi(this.data[0])
      //   }
      // })
    }
    // this.initPixi(this.data[0])
  },

  beforeDestroy() {
    this.destroyPixiApp()
  },

  data() {
    return {
      data: [],
      imgdata: 'earth',
      ids: 'pixi',
      num: 0,
      time: 0,
      oldtime: 0,
      iconwidth: 40,
      iconheight: 40,
      tickerCallback: null,
      app: null,
    }
  },
  methods: {
    openpage() {
      this.$router.push('/business/ddssc')
    },
    openpagetwo() {
      this.$router.push('/business/bsjs')
    },
    openpagethree() {
      this.$router.push('/business/inclusive')
    },
    openpagefour() {
      this.$router.push('/business/rhsjssb')
    },
    openpagefive() {
      this.$router.push('/business/zhsw')
    },
    openpagesix() {
      this.$router.push('/business/brsws')
    },
    replaceimg(data) {
      let originalUrl = data
      let newUrl = originalUrl.replace('http://www.p8c.com', 'http://localhost:8848')
      return newUrl
    },
    handleChange(index) {
      this.initPixi(this.data[index])
    },
    destroyPixiApp() {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].app != null) {
          this.data[i].app.ticker.stop()
        }
      }
    },
    openPixiApp() {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].app != null) {
          this.data[i].app.ticker.start()
        }
      }
    },
    async initPixi(data) {
      // 判断是否有canvas标签
      var parentElement = document.getElementById(data.id)
      var canvases = parentElement.querySelectorAll('canvas')

      if (canvases.length > 0) {
        console.log()
      } else {
        data.app = new PIXI.Application({
          width: window.innerWidth,
          height: window.innerHeight,
          backgroundColor: 0x1099bb,
          resolution: window.devicePixelRatio || 1,
          antialias: true, // 抗锯齿
        })
        document.getElementById(data.id).appendChild(data.app.view)
        // 加载图片
        // 创建一个纹理
        const texture = PIXI.Texture.from(`./textures/${data.name}.jpeg`)

        // const texture = await Assets.load(data.name)
        // const texture = await Assets.load(
        //   '/img/uploads/1/image/2024/05/20240517113949874_q0mc1mhhc929.jpg'
        // )
        // 创建一个精灵
        const sprite = new PIXI.Sprite(texture)
        sprite.width = data.app.screen.width
        sprite.height = data.app.screen.height

        // 创建容器
        const container = new PIXI.Container()
        container.filters = null
        // 将精灵添加到容器中
        container.addChild(sprite)
        // 将容器添加到舞台
        data.app.stage.addChild(container)

        // 添加置换滤镜
        const displacementSprite = PIXI.Sprite.from('./textures/clouds.jpg')
        displacementSprite.scale.set(2, 2)
        displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT

        const displacementFilter = new PIXI.DisplacementFilter(displacementSprite)
        container.addChild(displacementSprite)

        container.filters = [displacementFilter]
        this.tickerCallback = () => {
          displacementSprite.x += 2
          displacementSprite.y += 2
        }
        data.app.ticker.add(this.tickerCallback)
      }
    },
    lerp(start, end, t) {
      return start + t * (end - start)
    },
    delHandleMouseEnter() {
      this.$refs.carousel.handleMouseEnter = () => {}
    },
  },
}
</script>

<style>
.pixiiconcenter {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pixiiconitems {
  padding: 3px 0;
}
.pixiiconitem {
  flex: 1;
  color: #fff;
  font-size: 15px;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.pagehomeone {
  position: relative;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
canvas {
  width: 100vw;
  height: 100vh;
  position: fixed;
  /* overflow: hidden; */
  /* left: -2vw; */
  top: 0;
}

.pixicenter {
  position: absolute;
  top: 65%;
  left: 50%;
  width: 50vw;
  height: 20vh;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
}
.pixicenteritem {
  font-family: '黑体', serif;
  font-weight: bold;
  font-size: 30px;
  color: red;
  padding: 5px 0;
}

.progress {
  height: 60px;
  width: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 90%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}
.progressitem {
  font-size: 14px;
  color: #999;
}
.imgdata {
  width: 100%;
  height: 100%;
  background-size: cover;

  /* 设置背景位置为居中 */
  background-position: center center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
@media (max-width: 900px) {
  .pixicenter {
    top: 70%;
    width: 70vw;
  }
  .pixiiconitem {
    flex: 1;
    color: #fff;
    font-size: 8px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pixicenteritem {
    font-family: '黑体', serif;
    font-weight: bold;
    font-size: 24px;
    color: red;
    padding: 5px 0;
  }
}
@media (max-width: 550px) {
  .pixicenter {
    top: 70%;
    width: 100vw;
  }
  .pixicenteritem {
    font-family: '黑体', serif;
    font-weight: bold;
    font-size: 18px;
    color: red;
    padding: 5px 0;
  }
}
</style>
